import React from 'react';
import { COLORS } from '../../config/colors';

const GoldenButton = ({ children, onClick, className = '', ...props }) => {
  return (
    <button
      onClick={onClick}
      className={`
        bg-[#D4AF37] 
        text-white 
        rounded-full 
        hover:bg-[#C5A028] 
        transition-all 
        duration-300 
        shadow-md 
        border-2 
        border-[#FFD700] 
        hover:border-[#D4AF37]
        font-cursive
        text-xl
        ${className}
      `}
      style={{
        boxShadow: COLORS.button.primary.innerShadow
      }}
      {...props}
    >
      {children}
    </button>
  );
};

export default GoldenButton; 